module.exports = __webpack_public_path__ + "img/picto-cart@2x.aa0b1f2.png";